<script setup>

import { useLocale } from 'vuetify'
// import placeFieldVue from '@/components/AdvancedFields/placeField.vue'
// import rangeDatePicker from '@/components/AdvancedFields/rangeDatePicker.vue'
// import moreFilters from './subComponents/moreFilters.vue'

const { t } = useLocale()


</script>

<template>
   <div class="w-100 overflow-hidden">
        <v-carousel v-if="isHomepage" :cycle="true" :show-arrows="false" height="80vh" interval="10000">
            <v-carousel-item v-for="(item, i) in carouselItemsPromo" :key="i">
                <v-img cover height="80vh" :src="getImageSource(item)" :alt="item.alt">
                    <v-container>
                        <div class="d-flex flex-column justify-space-between" style="height: 80vh;">
                            <div class="d-flex align-center" :style="{ 'height': $vuetify.display.mdAndUp ? '80vh' : '80vh' }">
                                <v-row class="pb-16">
                                    <v-col cols="12">
                                        <div>
                                            <h2 data-aos="fade-right" class="text-h3 text-lg-h2 text-xl-h1 shadow-text font-weight-bold mb-8">
                                                {{ $vuetify.locale.current === 'it' ? item.titleIt : item.titleEn }}
                                            </h2>
                                            <h3 data-aos="fade-right" class="text-h5 text-lg-h4 text-xl-h3 shadow-text font-weight-medium mb-12">
                                                {{ $vuetify.locale.current === 'it' ? item.subtitleIt : item.subtitleEn }}
                                            </h3>
                                            <div data-aos="fade-right" class="d-flex align-center text-h5 text-lg-h5 text-xl-h5 shadow-text font-weight-regular mb-8">
                                                <img :src="item.brandLogoSrc" alt="Brand Logo" class="mr-3" height="30" />
                                                <div>
                                                    {{ item.model }}
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-row class="pb-16 text-center align-content-end">
                                <v-col cols="12">
                                    <v-btn color="secondary" height="72" min-width="300" @click="requestQuote">
                                        <span class="font-weight-bold text-body-1 text-uppercase">
                                            {{ t('commons.requestQuote') }}
                                            <!-- {{ t('commons.contactUsAt') }} <span class="text-primary">+39 06 3322 0167</span> -->
                                        </span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </v-img>
            </v-carousel-item>
        </v-carousel>

        <template v-else>
            <v-container class="z-index-5 position-relative py-lg-5">
                <v-row>
                    <v-col cols="12">
                        <span v-if="data.is_h1">
                            <h1 class="text-h4 mb-5 text-md-h3" data-aos="fade-right" v-html="data.title"></h1>
                            <h2 class="text-h6 text-md-h5" data-aos="fade-right"  v-html="data.sub_title"></h2>
                        </span>
                        <span v-else>
                            <h2 class="text-h4 mb-5 text-md-h3" data-aos="fade-right" v-html="data.title"></h2>
                            <h3 class="text-h6 text-md-h5" data-aos="fade-right"  v-html="data.sub_title"></h3>
                        </span>
                    </v-col>
                </v-row>
            </v-container>
            <v-img
                lazy
                v-if="data.has_image"
                cover
                :alt="data.title"
                fetchpriority="high"
                class="mt-n16 mx-auto"
                :position="data.image_position_x+'% '+data.image_position_y+'% '"
                :lazy-src="data.image.sizes.medium"
                :height="imgheight()"
                :src="data.image.sizes.full"
                width="100%"
                gradient="to bottom, rgba(0,0,0,1), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,1)"
            >
            </v-img>
            <div v-else class="py-10"></div>
            <div class="pb-12">
                <v-row justify="center">
                    <v-col cols="12" md="10" class="text-center">
                        <v-btn color="brown" size="x-large" @click="requestQuote">{{ t('commons.requestQuote') }}</v-btn>
                    </v-col>
                </v-row>
            </div>
        </template>

        <!-- <div v-if="isHomepage && isItalianLocale" class="bg-tertiary py-12 px-3">
            <div :class="{ 'd-flex justify-center align-center': $vuetify.display.mdAndUp }" class="text-center">
                <div :class="{ 'mx-8': $vuetify.display.mdAndUp, 'mb-4': $vuetify.display.smAndDown }" class="mx-8 text-h5 font-weight-bold">
                    {{ t('commons.discoverPromo') }}
                </div>
                <div :class="{ 'mx-8': $vuetify.display.mdAndUp }">
                    <v-btn color="secondary" min-width="300" @click="requestQuote">
                        <span class="font-weight-bold text-body-1 text-uppercase">
                            {{ t('commons.requestQuote') }}
                        </span>
                    </v-btn>
                </div>
            </div>
        </div> -->
    <!-- <v-form ref="searchForm" v-model="valid" @click="trackFocusEvent">
    <v-row class="overtop-100" data-aos="fade-up">
        <v-col class="my-5 mx-auto elevation-0" cols="12" md="10" lg="10">
                    <v-card class="bg-transparent elevation-0 my-5"  >
                        <v-card-text :key="ready">
                            <v-row align="center">
                                <v-col cols="12" md="6" lg="4">
                                    <placeFieldVue
                                     :preValue="search.start"
                                     @update="setLocationStart"
                                     label="attributes.location_start.label"
                                    ></placeFieldVue>
                                </v-col>
                                <v-col cols="12" md="6" lg="4">
                                    <placeFieldVue
                                    :preValue="search.end"
                                     @update="setLocationEnd"
                                     label="attributes.location_end.label"
                                    ></placeFieldVue>
                                </v-col>
                                <v-col cols="12" md="12" lg="4">
                                    <range-date-picker
                                        :focus="data.default.autoopendates"
                                        @update="setDates"
                                        :preValue="search"
                                        :label="t('attributes.date_range.label')">
                                    </range-date-picker>
                               </v-col>
                               <v-col cols="12" md="6" lg="4">
                                    <v-select
                                        name="type"
                                        hide-details
                                        :items="sortBy(types, 'label')"
                                        item-title="label"
                                        item-value="id"
                                        variant="outlined"
                                        v-model="search.filter.type"
                                        class="bg-search"
                                        :label="t('attributes.car_types.label')"
                                        clearable
                                        chips
                                        multiple
                                        density="compact"
                                        id="typesIds"
                                    ></v-select>
                               </v-col>
                               <v-col cols="12" md="6" lg="4">
                                    <v-select
                                        name="brand"
                                        hide-details
                                        :items="sortBy(brands, 'name')"
                                        item-title="name"
                                        item-value="id"
                                        clearable
                                        chips
                                        multiple
                                        density="compact"
                                        variant="outlined"
                                        class="bg-search"
                                        v-model="search.filter.brand"
                                        :label="t('attributes.car_brand.label')"
                                        id="brandIds"
                                    ></v-select>
                               </v-col>
                               <v-col cols="12" md="12" lg="4">
                                <v-btn
                                    variant="text"
                                    block
                                    class="btn-primelinks"
                                    @click="openFilters = !openFilters"
                                >
                                 <span class="text-underline me-5">
                                    {{ t('attributes.more_filters.label') }}
                                 </span>
                                 <v-icon class="ms-5">mdi-tune-variant</v-icon>
                                </v-btn>
                               </v-col>
                               <v-col v-if="openFilters" cols="12">
                                <more-filters :filters="search.filter"></more-filters>
                               </v-col>
                               <v-col cols="12" lg="8" class="mx-auto">
                                    <v-btn @click="searchNow" rounded="pill" size="large" :loading="loading" :variant="valid ? 'elevated' : 'outlined'" block color="primary">
                                        <span class="text-white">
                                        <v-icon class="me-3">mdi-magnify</v-icon> {{t('commons.search')}}
                                        </span>
                                    </v-btn>
                               </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text id="jsonsearch" class="d-none">
                            <pre>{{ search }}</pre>
                        </v-card-text>
                    </v-card>
                </v-col>
        </v-row>
    </v-form> -->
   </div>
</template>



<script>
import {mapGetters} from "vuex";
export default {
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            brands: 'carsDrive/brands',
            models: 'carsDrive/models',
            types: 'carsDrive/types',
            search: 'driveSearch/search',
        }),
        isXs() {
            return this.$vuetify.display.name === 'xs';
        },
        isSmAndUp() {
            return this.$vuetify.display.name === 'sm' || this.$vuetify.display.name === 'md' || this.$vuetify.display.name === 'lg' || this.$vuetify.display.name === 'xl' || this.$vuetify.display.name === 'xxl';
        },
        isHomepage() {
            return this.$route.path === '/it' || this.$route.path === '/en';
        },
        isItalianLocale() {
            return this.$vuetify.locale.current === 'it';
        },
    },
    mounted(){

        if(this.data.is_h1 == undefined){
            this.data.is_h1 = true;
        }

        this.$store.dispatch('driveSearch/checkRecents');


        this.$store.dispatch('carsDrive/getBrands', {online:true, availableOnly: true})
        this.$store.dispatch('carsDrive/getModels', {online:true, availableOnly: true})


        this.$store.dispatch('carsDrive/getTypes')


        if(this.$route.query){
            this.checkRouterQuery()
        }

        this.checkDeafultsData()

        this.search.filter = this.mergeObjects( this.search.filter, this.data.default.filter)
        this.search.start = this.mergeObjects( this.search.start, this.data.default.start)
        this.search.end = this.mergeObjects( this.search.end, this.data.default.end)

        this.moreFiltersOpener();

        this.ready = true;

    },
    data: () => ({
        valid: null,
        focused: false,
        ready: null,
        openFilters: false,
        rules:{
            required: value => !!value || 'attributes.generic.validation.required',
        },
        breakpoints: {
            xs: 320,
            sm: 360,
            md: 380,
            lg: 460,
            xl: 500,
            xxl: 550,
        },
        carouselItems: [
            {
                srcLg: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes-Benz-Classe-G/Mercedes-Benz-Classe-G_1920x940.jpg',
                srcMd: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes-Benz-Classe-G/Mercedes-Benz-Classe-G_1080x678.jpg',
                srcSm: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes-Benz-Classe-G/Mercedes-Benz-Classe-G_720X940.jpg',
                alt: 'Mercedes Benz GLE',
                titleIt: 'Oltre 500 auto premium',
                titleEn: 'Over 500 premium cars',
                descriptionIt: 'Tutti veicoli di proprietà, full optional e in pronta consegna',
                descriptionEn: 'All owned, fully equipped, and ready for immediate delivery',
            },
            {
                srcLg: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Audi_SQ8/Audi-SQ8_1920x940.jpg',
                srcMd: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Audi_SQ8/Audi-SQ8_1080x678.jpg',
                srcSm: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Audi_SQ8/Audi-SQ8_720X940.jpg',
                alt: 'Audi SQ8',
                titleIt: 'Consegna e ritiro personalizzati',
                titleEn: 'Tailored delivery and pickup',
                descriptionIt: 'L\'auto dove e quando vuoi, in tutta Italia e sud Europa',
                descriptionEn: 'Your car, wherever and whenever you need it in Italy and southern Europe',
            },
            {
                srcLg: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Aston_Martin_DB12/Aston-Martin-DB12_1920x940.jpg',
                srcMd: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Aston_Martin_DB12/Aston-Martin-DB12_1080x678.jpg',
                srcSm: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Aston_Martin_DB12/Aston-Martin-DB12_720x940.jpg',
                alt: 'Aston Martin DB12',
                titleIt: 'Assistenza dedicata',
                titleEn: 'Dedicated support',
                descriptionIt: 'Supporto H24, multilingue e con account specializzato',
                descriptionEn: '24/7 multilingual assistance with a personal account manager',
            },
            {
                srcLg: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Range_Rover_Sport/RR-Sport_1920x940.jpg',
                srcMd: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Range_Rover_Sport/RR-Sport_1080x678.jpg',
                srcSm: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Range_Rover_Sport/RR-Sport_720X940.jpg',
                alt: 'Range Rover Sport',
                titleIt: 'Noleggio su misura',
                titleEn: 'Tailored rental solutions',
                descriptionIt: 'Soluzioni flessibili per ogni tua esigenza',
                descriptionEn: 'Custom options designed around your specific needs',
            },
        ],
        carouselItemsPromo: [
            {
                srcLg: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes_GLS/IMG_1920x940.jpg',
                srcMd: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes_GLS/IMG_1080x678.jpg',
                srcSm: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes_GLS/IMG_720X940.jpg',
                brandLogoSrc: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/brand_logos/mercedes.png',
                alt: 'Mercedes GLS',
                titleIt: 'Servizio su misura in tutta Europa',
                titleEn: 'Tailor-made service across Europe',
                subtitleIt: 'Noleggio da 1 giorno a 12 mesi, in qualsiasi città europea',
                subtitleEn: 'Rentals from 1 day to 12 months, in any European city',
                model: 'Mercedes GLS',
            },
            {
                srcLg: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/RR_Sport__2/IMG_1920x940.jpg',
                srcMd: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/RR_Sport__2/IMG_1080x678.jpg',
                srcSm: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/RR_Sport__2/IMG_720X940.jpg',
                brandLogoSrc: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/brand_logos/land_rover.png',
                alt: 'Range Rover Sport',
                titleIt: 'Consegna e ritiro su richiesta',
                titleEn: 'Personalized pick-up and drop-off',
                subtitleIt: 'Massima flessibilità: scegli tu luogo e orario, in tutta Europa',
                subtitleEn: 'Maximum flexibility: you choose the time and place, anywhere in Europe',
                model: 'Range Rover Sport',
            },
            {
                srcLg: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes-Benz_GLE/IMG_1920x940.jpg',
                srcMd: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes-Benz_GLE/IMG_1080x678.jpg',
                srcSm: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/Mercedes-Benz_GLE/IMG_720X940.jpg',
                brandLogoSrc: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/brand_logos/mercedes.png',
                alt: 'Mercedes-Benz GLE 63 AMG',
                titleIt: 'Guida l\'auto che desideri',
                titleEn: 'Drive the car you want',
                subtitleIt: 'Sempre modello garantito e brand new',
                subtitleEn: 'Always the guaranteed model, brand new',
                model: 'Mercedes-Benz GLE 63 AMG',
            },
            {
                srcLg: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/BMW_X5/IMG_1920x940.jpg',
                srcMd: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/BMW_X5/IMG_1080x678.jpg',
                srcSm: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/BMW_X5/IMG_720X940.jpg',
                brandLogoSrc: 'https://primerent-images-public.s3.eu-central-1.amazonaws.com/website/home/brand_logos/bmw.png',
                alt: 'BMW X5',
                titleIt: 'Auto di proprietà, in pronta consegna',
                titleEn: 'Owned cars, ready to drive',
                subtitleIt: 'Bastano poche ore per guidare la tua nuova auto a noleggio',
                subtitleEn: 'Just a few hours to get behind the wheel of your rental car',
                model: 'BMW X5',
            },
        ],
    }),
    methods:{
        callRequest() {
            window.location.href = 'tel:+390633220167';
        },
        getImageSource(item) {
            const bp = this.$vuetify.display
            if (bp.xs) return item.srcSm
            if (bp.sm || bp.md) return item.srcMd
            return item.srcLg
        },
        trackFocusEvent(){
            if(!this.focused){
                this.focused = true;
                this.$gtm.trackEvent({
                    event: 'step_0_view_form',
                    search_value: {
                        "pickup_location": this.search.start.description,
                        "delivery_location":  this.search.end.description,
                        "rental_date": this.search.start.date+" - "+this.search.end.date
                    }
                })
            }
        },
        imgheight(){
            return this.breakpoints[this.$vuetify.display.name]
        },
        setDates(val){
            this.search.start.date = val.startDate
            this.search.end.date = val.endDate
        },
        mergeObjects(obj1, obj2){
            let mergedObj = Object.assign({}, obj1);

            for (let key in mergedObj) {

                if(obj1[key]){
                    if(obj1[key].length >= 1){
                        mergedObj[key] = obj1[key]
                    }
                }
                if(obj2){
                    if(obj2.hasOwnProperty(key)){
                        if(obj2[key]){
                            if(obj2[key].length >= 1){
                                mergedObj[key] = obj2[key];
                            }
                        }
                    }
                }

            }


            return mergedObj;
        },
        checkDeafultsData(){
            if(this.data.default.pretime){
                let queryPretimes = this.getDatesPretime(this.data.default.pretime);
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.start = {...this.data.default.start, ...{date: queryPretimes[0]}}
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.end = {...this.data.default.end, ...{date: queryPretimes[1]}}

            }
            if(this.data.default.start){
                if(this.data.default.start.description){
                    this.setLocationStart(this.data.default.start)
                }
            }
            if(this.data.default.end){
                if(this.data.default.end.description){
                    this.setLocationEnd(this.data.default.end)
                }
            }

        },
        checkRouterQuery(){

            if(this.$route.query.car_type){
                let queryType = {
                    type: [ Number(this.$route.query.car_type) ]
                }
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.filter = {...this.data.default.filter, ...queryType}
            }
            if(this.$route.query.car_brand){
                let queryBrand = {
                    brand: [ Number(this.$route.query.car_brand) ]
                }
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.filter = {...this.data.default.filter, ...queryBrand}
            }
            if(this.$route.query.car_model){
                let queryModel = {
                    model: [ Number(this.$route.query.car_model) ]
                }
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.filter = {...this.data.default.filter, ...queryModel}
            }

            if(this.$route.query.start_date){
                // eslint-disable-next-line vue/no-mutating-props
                let  queryStart = {
                    date: this.$route.query.start_date
                };
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.start = {...this.data.default.start, ...queryStart}
            }
            if(this.$route.query.end_date){
                // eslint-disable-next-line vue/no-mutating-props
                let  queryEnd = {
                    date: this.$route.query.end_date
                };
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.end = {...this.data.default.start, ...queryEnd}
            }

            if(this.$route.query.pretime){
                let queryPretimes = this.getDatesPretime(this.$route.query.pretime);
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.start = {...this.data.default.start, ...{date: queryPretimes[0]}}
                // eslint-disable-next-line vue/no-mutating-props
                this.data.default.end = {...this.data.default.end, ...{date: queryPretimes[1]}}
            }

        },
        moreFiltersOpener(){

            let tocheck = [
                'model',
                'fuel',
                'gear',
                'seats',
                'drive',
                'color',
            ]

            tocheck.forEach(element => {
                if(this.search.filter){
                    if(this.search.filter[element]){
                        if(this.search.filter[element].length > 0){
                            this.openFilters = true;
                        }
                    }
                }
            });

        },
        setLocationStart(val){
            this.search.start = {... this.search.start, ...val}
        },
        setLocationEnd(val){
            this.search.end = {...this.search.end, ...val}
        },
        requestQuote() {
            this.$gtm.trackEvent({
                'event':'requestQuoteButtonClicked'
            })
            const uri = this.$vuetify.locale.current == 'it' ? '/it/ricerca/quotazione-personalizzata' : '/en/search/personalized-quote'
            this.$router.push(uri);
        },
        async searchNow(){
            await this.$refs.searchForm.validate()
                this.$gtm.trackEvent({
                    event: 'step_0_compilazione',
                    search_value: {
                        "pickup_location": this.search.start.description,
                        "delivery_location":  this.search.end.description,
                        "rental_date": this.search.start.date+" - "+this.search.end.date
                    }
                })

                event.preventDefault()
                if(this.valid){
                    this.$store.dispatch('driveSearch/resetErrors');
                    // this.$store.dispatch('driveSearch/search', this.search).then(() => {
                         this.$router.push({name:'search-result'})
                    // })
                }else{

                    this.$gtm.trackEvent({
                        event: 'step_0_ERRORE_compilazione',
                        search_value: {
                            "pickup_location": this.search.start.description,
                            "delivery_location":  this.search.end.description,
                            "rental_date": this.search.start.date+" - "+this.search.end.date
                        }
                    })

                }

        },
        sortBy(array, key) {
            return array.sort(function(a, b) {
                var x = a[key]; var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },
        getDatesPretime(type){
            let today = this.$moment()
            let start = null;
            let end = null;

            if(type == "next-weekend"){
                let dayOftheweek = today.isoWeekday();
                if( dayOftheweek >= 5){
                    start = this.$moment().startOf('isoWeek').add(1, 'week').add(4, 'days').add(10,'hours');
                    end = this.$moment().startOf('isoWeek').add(1, 'week').add(4, 'days').add(3,'days').add(10,'hours');
                }else{
                    start = this.$moment().startOf('isoWeek').add(4, 'days').add(10,'hours');
                    end = this.$moment().startOf('isoWeek').add(4, 'days').add(3,'days').add(10,'hours');
                }
            }

            if(type == "nextweek"){

                start = this.$moment().startOf('isoWeek').add(1, 'week').add(10,'hours');
                end = this.$moment().startOf('isoWeek').add(1, 'week').add(7,'days').add(10,'hours');

            }

            return [start, end];

        },
    }
}
</script>

<style scoped>

.overtop-100{
    position: relative;
    top: -100px;
    margin-bottom: -100px;
}

.shadow-text {
    text-shadow: 1px 1px 4px rgba(0,0,0,0.7);
}
</style>

<style>
.custom-bordered-text {
    border: 1px solid rgb(var(--v-theme-primary));
    display: inline-block;
    padding: 1px 4px;
    border-radius: 4px;
    margin-right: 16px;
}
.v-carousel__controls {
    background: none !important;
    color: white;
}
</style>
